module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Customer List")]), _vm._v(" "), _c('div', {
    staticClass: "action-button pull-right"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "reset-input",
      rawName: "v-reset-input"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.searchCustomer),
      expression: "searchCustomer"
    }],
    staticClass: "form-control mrgn-right-20px searchBox",
    attrs: {
      "type": "text",
      "placeholder": "Type here to search and press 'Enter'"
    },
    domProps: {
      "value": (_vm.searchCustomer)
    },
    on: {
      "keyup": _vm.searchCustomer1,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchCustomer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "Customer-addOrUpdate"
    }
  }, [_vm._v("Add Customer")])], 1)]), _vm._v(" "), (_vm.actionInProgress) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/loader/nivi-loader.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped table-apps"
  }, [_c('thead', [_c('th', [_vm._v("Customer Name "), _c('i', {
    staticClass: "fa fa-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortCustomer('data.name', 'asc')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortCustomer('data.name', 'desc')
      }
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', [_vm._v("Contract")]), _vm._v(" "), _c('th', [_vm._v("Created On")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Status")])]), _vm._v(" "), _c('tbody', [(_vm.customerData.length === 0 && !_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No Result found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.customerData), function(keyword, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.customerData.length),
        expression: "customerData.length"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(keyword.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(keyword.country_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.customerContractList.find(function (item) { return item.value === keyword.contract_status; }).name))]), _vm._v(" "), _c('td', [(keyword.createdAt) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(keyword.createdAt, 'd/M/Y hh:ss')))]) : _vm._e(), _vm._v(" "), (!keyword.createdAt) ? _c('span', [_vm._v("--")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("Customer-addOrUpdate?customerId=" + (keyword.id))
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', [(!keyword.is_deleted) ? _c('span', {
      staticClass: "badge badge-pill btn-success",
      on: {
        "click": function($event) {
          return _vm.showDeleteConfirmationPopup(keyword, index)
        }
      }
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (keyword.is_deleted) ? _c('span', {
      staticClass: "badge badge-pill btn-danger",
      on: {
        "click": function($event) {
          return _vm.showDeleteConfirmationPopup(keyword, index)
        }
      }
    }, [_vm._v("Inactive")]) : _vm._e()])])
  })], 2)])])])])])]), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('deleteConfirmationModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteCustomer": _vm.deleteCustomer,
      "deactiveCustomer": _vm.deactiveCustomer,
      "activeCustomer": _vm.activeCustomer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Customer Management\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Customer")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Customer List")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-dcf35b1e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer-management/customerList.vue
// module id = A5Xv
// module chunks = 1